<template>
    <!-- Modal -->
    <div class="modal fade" id="add_new_area_modal" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="myModalLabel2">Add New Area</h4>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="saveArea">
                        <div class="row form-group">
                            <div class="col-md-6"><input type="text" v-model="areaObj.name" class="form-control" placeholder="Area Name" required/></div>
                            <div class="col-md-6">
                                <select required="required" v-model="areaObj.citiesByCityId.id" class="form-control">
                                    <option value="">Select City</option>
                                    <option v-for="city in cities" v-bind:key="'city_sel_'+city.id" v-bind:value="city.id">{{city.city}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-6"><input v-model="marker.lng" type="text" disabled required class="form-control" placeholder="Longitude" /></div>
                            <div class="col-md-6"><input v-model="marker.lat" type="text" disabled required class="form-control" placeholder="Latitude" /></div>
                        </div>
                        <div class="form-group">
                            <label>
                                <input v-model="areaObj.isBranch" type="checkbox"/> Branch Area
                            </label>
                            <button v-if="areaObj.id===0" style="margin-bottom:10px;" type="submit" :disabled="marker.lat===0.0" class="btn btn-primary pull-right">Save</button>
                            <button v-else style="margin-bottom:10px;" type="submit" :disabled="marker.lat===0.0" class="btn btn-primary pull-right">Update</button>
                        </div>
                        
                    </form>
                    <div class="search-place-map">
                            <gmap-autocomplete
                            class="form-control"
                            id="location"
                            @place_changed="setAddress">
                            </gmap-autocomplete>
                    </div>
                    <br>
                    <gmap-map
                         :options="{
                        zoomControl: true,
                        mapTypeControl: false,
                        }"
                        :center="center"
                        :zoom="zoom"
                        style="width:100%;  height: 500px;"
                        @click="addMarker($event)"
                        >
                        <gmap-marker
                          :draggable="true"
                          @dragend="updateMarker($event.latLng)"
                        :position="marker"
                        ></gmap-marker>
                    </gmap-map>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import {getAreasFromLatLng} from "@/api/areas";

    export default {
        name: "AddNewArea",
        data() {
            return {
                center: { lat: 31.5204, lng: 74.3587 },
                marker:{
                    lat:0.0,
                    lng:0.0
                },
                selectedAddress: null,
                zoom:12,
                cities:'',
                areaObj:{
                    id:0,
                    name:"",
                    lat:"",
                    lng:"",
                    citiesByCityId:{
                        id:''
                    },
                    isBranch:'',
                    approved:0
                },
                userRole:'',
                updateArea: false
            }
        },
        mounted: function(){
            $('#add_new_area_modal').on('hidden.bs.modal',  (e) => {
                this.resetData();
            });
            
        },
        methods: {
          async updateMarker(location){
            let formData = new FormData();
            formData.append("latlng", location.lat() +","+location.lng());
            const res = await getAreasFromLatLng(formData);
            this.marker.lat = location.lat()
            this.marker.lng = location.lng()
            $("#location").val(res.data)
          },
            load: function(cities){
                this.cities= cities;
                $("#add_new_area_modal").modal("show");
            },
            loadForUpdate: function(cities, areaId){
                this.cities=cities;
                this.updateArea= true;
                this.$http.get(this.$store.state.mainAppURL+"areas/" + areaId).then(resp=>{
                    this.areaObj= resp.data;
                    this.marker.lat= resp.data.lat;
                    this.marker.lng= resp.data.lng;
                    this.center= $.extend(true, {}, this.marker);
                    $("#add_new_area_modal").modal("show");
                });
            },
        setAddress(address) {
        this.zoom=12;
        this.selectedAddress = address;
        if(this.selectedAddress.geometry!==undefined){
            this.center= {lat: this.selectedAddress.geometry.location.lat(), lng: this.selectedAddress.geometry.location.lng()}
            this.marker.lat=this.selectedAddress.geometry.location.lat();
            this.marker.lng= this.selectedAddress.geometry.location.lng();
        }

        },
        addMarker(event){
            this.marker.lat=event.latLng.lat();
            this.marker.lng= event.latLng.lng();
            this.zoom=15;
        },
        saveArea: function(){
            this.areaObj.lat= this.marker.lat;
            this.areaObj.lng= this.marker.lng;
            this.userRole= this.$store.state.user.userRolesById[0].role.split('_')[1]
            if(this.userRole==='ADMIN' && !this.updateArea){
                this.areaObj.approved=1;
            }
            Swal.fire({
                title: 'Please Wait! We are processing the data.',
                type: 'info',
                allowOutsideClick: false,
                allowEscapeKey: false,
                onBeforeOpen: () => {
                    Swal.showLoading();
                },
            });
            this.$http.post(this.$store.state.mainAppURL + "areas/", this.areaObj).then(resp=>{
                this.updateArea=false;
                $("#add_new_area_modal").modal("hide");
                Swal.close();
                this.$parent.tableDraw();
                swal("Saved!" ," Area Has Been Saved", "success");

        }).catch(err=>{
            swal("Failed", err + "Failed to save new area. Please contact DVM Tech Support", 'error');
        });
        },
        resetData: function(){
            this.areaObj={
                id:0,
                name:"",
                lat:"",
                lng:"",
                citiesByCityId:{
                    id:''
                },
                isBranch:''
            };
            this.marker={
                    lat:0.0,
                    lng:0.0
                };
            this.center= { lat: 31.5204, lng: 74.3587 };
            this.selectedAddress=null;
        },
        }
    }
</script>

<style>
.pac-container{
z-index: 3000 !important;
}
</style>
